export const MODIFY_ACTION = 'action';

export const ACTION_TYPE = 'actionType';
export const SKIP = 'skip';
export const OPERATOR = 'operator';
export const VALUE = 'value';
export const LIMIT = 'limit';
export const ASK_FOR_APPROVAL = 'isActionApproveRequired';

export const NONE = 'None';
